"use client";

const services = [
    "AI Integration & Development",
    "Website Development",
    "Mobile App Development",
    "Desktop Software",
    "E-commerce Solutions",
    "ETL Pipelines",
    "Fast MVP Development",
    "UI/UX Design"
];

export default function ServicesMarquee() {
    return (
        <div className="w-full bg-black py-4 overflow-hidden flex whitespace-nowrap relative z-10 border-t border-white/10">
            <div
                className="flex items-center gap-8 whitespace-nowrap animate-marquee"
                style={{ animationDuration: "40s" }}
            >
                {/* Triplicate the list to ensure smooth looping without gaps */}
                {[...services, ...services, ...services, ...services].map((service, i) => (
                    <div key={i} className="flex items-center gap-8 text-white/90 text-sm font-mono uppercase tracking-widest flex-shrink-0">
                        <span>{service}</span>
                        <span className="text-primary text-lg leading-none pt-1">✦</span>
                    </div>
                ))}
            </div>
        </div>
    );
}
